export const processHtmlContent = (html: string) => {
  let processedHtml = html
    .replace(/dir="ltr"/g, '')
    .replace(/role="presentation"/g, '')
    .replace(/aria-level="1"/g, '')

  // Remove <p> de dentro de <li>
  processedHtml = processedHtml.replace(
    /<li([^>]*)>\s*<p[^>]*>(.*?)<\/p>\s*<\/li>/g,
    '<li$1>$2</li>',
  )

  // Adiciona estilos nas listas
  processedHtml = processedHtml
    .replace(/<ul/g, '<ul style="padding-left: 20px; margin-bottom: 8px;"')
    .replace(/<ol/g, '<ol style="padding-left: 20px; margin-bottom: 8px;"')
    .replace(/<li/g, '<li style="margin-bottom: 4px;"')

  // Adiciona estilos nos <p> fora de <li>
  processedHtml = processedHtml.replace(
    /(<p(?![^>]*style=)[^>]*>)/g,
    '<p style="margin-bottom:8px;">',
  )

  // Adiciona estilos nos <h3> (apenas se não houver style)
  processedHtml = processedHtml.replace(
    /<h3(?![^>]*style=)/g,
    '<h3 style="font-weight:bold;font-size:18px;margin-bottom:8px;"',
  )

  return processedHtml
}
